import $ from 'jquery';
window.$ = window.jQuery = $;

require('bootstrap');
require('jquery-lazy');
require('slick-carousel');

//Lazy Load Images
$(function() {
	$('.lazy').Lazy({
		effect: 'fadeIn',		
		visibleOnly: true,
		threshold: 300,
		afterLoad: function(element) {
			$(element).removeClass("loader");
		}
	});
});

$(".product-slider").slick({
	lazyLoad: 'ondemand',
	prevArrow:'<div class="slider-nav slider-prev"><img src="/images/ui/prev.png" alt="Previous Slide" /></div>',
	nextArrow:'<div class="slider-nav slider-next"><img src="/images/ui/next.png" alt="Next Slide" /></div>'
});

$(".panel-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false
});

$(document).ready(function() {

  var toggleAffix = function(affixElement, scrollElement, wrapper) {
  
	var height = affixElement.outerHeight(),
		top = wrapper.offset().top;
	
	if (scrollElement.scrollTop() >= top){
		wrapper.height(height);
		affixElement.addClass("affix");
	}
	else {
		affixElement.removeClass("affix");
		wrapper.height('auto');
	}
	  
  };

  $('[data-toggle="affix"]').each(function() {
	var ele = $(this),
		wrapper = $('<div></div>');
	
	ele.before(wrapper);
	$(window).on('scroll resize', function() {
		toggleAffix(ele, $(this), wrapper);
	});
	
	// init
	toggleAffix(ele, $(window), wrapper);
  });
  
  //Wait 1 second to let the page load
  //Otherwise the scroll thing keep firing
  setTimeout(
	function() {
	  
	  constructionMenuActive();
	  
	  $(window).on('resize scroll', function() {
		
		constructionMenuActive();
		
	  });
	  
	}, 1000
	
  );
  
});

$.fn.isInViewport = function() {
  
  //default
  var active = false;
  var viewable = 0;
  var viewable_percent = 0;
  
  var windowHeight = $(window).height();
  
  //element
  var elementTop = $(this).offset().top;
  var elementHeight = $(this).outerHeight();
  var elementBottom = elementTop + elementHeight;
  
  //viewport
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  
  //calculated
  var from_top = elementTop - viewportTop;

  //top of the element is viewable
  if(from_top > 0 && from_top < windowHeight) {
	
	if(from_top + elementHeight < windowHeight) {
	  viewable = elementHeight;
	} else {
	  viewable = windowHeight - from_top;
	}
	
  }
  
  //bottom of the element is viewable
  if(from_top < 0 && elementHeight + from_top > 0) {
	
	viewable = elementHeight + from_top;
	
  }
  
  if(viewable > 0) {
	active = true;
	viewable_percent = Math.round((viewable/windowHeight)*100);
  }
  
  return viewable_percent;
  
};

function constructionMenuActive() {
  
  $('.construction-section').each(function() {
	
	var activeSection = $(this).attr('id');
	var viewable_percent = $(this).isInViewport();
	
	$('#header-' + activeSection).attr('data-viewable',viewable_percent);
	
	if (viewable_percent > 0) {
	  $('#header-' + activeSection).addClass('active');
	} else {
	  $('#header-' + activeSection).removeClass('active');
	}
	
  });
  
  //multiple in viewport. which one is showing more.
  if($('.construction-navigation a.active').length > 1) {
	
	var num = $(".construction-navigation a.active").map(function() {
	  return $(this).attr('data-viewable');
	}).get();//get all data values in an array
	
	var highest = Math.max.apply(Math, num);//find the highest value from them
	
	$(".construction-navigation a").filter(function(){
		return $(this).attr('data-viewable') != highest;
	}).removeClass('active');
  }
  
}